import {
  AdjustmentsHorizontalIcon,
  ArrowDownTrayIcon,
  EllipsisVerticalIcon
} from '@heroicons/react/24/outline';
import PropTypes from 'prop-types';

const StatCards = ({ cards = [] }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card, idx) => (
        <div
          key={idx}
          className={`workspace-stat-card rounded-md border ${card.color} flex flex-col justify-between`}
        >
          <div className="flex justify-between items-start p-4 pb-0">
            <h2 className="workspace-stat-card-title text-lg font-semibold">{card.title}</h2>

            <div className="workspace-stat-card-tools flex items-center gap-2">
              <AdjustmentsHorizontalIcon className="w-4 h-4" />
              <ArrowDownTrayIcon className="w-4 h-4" />
              <EllipsisVerticalIcon className="w-4 h-4" />
            </div>
          </div>

          <div className="workspace-stat-card-value px-4 pt-2 text-3xl font-bold">
            {card.value}{' '}
            <span className="workspace-stat-card-unit text-base font-normal">{card.unit}</span>
          </div>

          <div className="workspace-stat-card-footer mt-4 border-t p-2 px-4 text-sm">
            {card.sub}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatCards;

StatCards.propTypes = {
  cards: PropTypes.arrayOf(PropTypes.object)
};
